module.exports = __webpack_public_path__ + "img/iphone.23c82af4.png";